import { render, staticRenderFns } from "./bafylc.vue?vue&type=template&id=298a8ba0&scoped=true&"
import script from "./bafylc.vue?vue&type=script&lang=js&"
export * from "./bafylc.vue?vue&type=script&lang=js&"
import style0 from "./bafylc.vue?vue&type=style&index=0&id=298a8ba0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298a8ba0",
  null
  
)

export default component.exports